import { initDataUnsafe } from '@twa-dev/sdk';

console.log('API_BASE_URL:', process.env.REACT_APP_API_URL);

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://sittersandtutors.ru/api';

export const endpoints = {
  'nanny-search': '/leads/nanny-search',
  'teacher-search': '/leads/teacher-search',
  'housekeeper': '/leads/housekeeper-search',
  'nanny': '/leads/nanny-application'
};

export const submitForm = async (formData, category) => {
  try {
    const endpoint = endpoints[category];
    if (!endpoint) {
      throw new Error('Неизвестная категория формы');
    }

    // Получаем initData из WebApp
    const WebApp = window.Telegram?.WebApp;
    if (!WebApp?.initDataUnsafe) {
      throw new Error('Не удалось получить данные инициализации Telegram');
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Telegram-Init-Data': WebApp.initData
      },
      body: JSON.stringify(formData)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.detail || 'Ошибка сервера');
    }

    return true;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const checkRequiredFields = (formData, category) => {
  const requiredFields = {
    'nanny-search': ['location', 'childrenInfo', 'schedule', 'duties', 'fullName', 'contacts'],
    'teacher-search': ['location', 'childrenInfo', 'schedule', 'duties', 'fullName', 'contacts'],
    'housekeeper-search': ['location', 'houseInfo', 'schedule', 'duties', 'fullName', 'contacts'],
    'nanny-application': ['name', 'birthDate', 'citizenship', 'education', 'location', 'languages', 'experience', 'skills', 'aboutMe', 'desiredSchedule', 'desiredSalary', 'contacts']
  };

  const fields = requiredFields[category] || [];
  return fields.every(field => {
    const value = formData[field];
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === 'object') {
      return Object.values(value).some(v => v !== null && v !== undefined && v !== '');
    }
    return value !== null && value !== undefined && value !== '';
  });
};

export const checkDataSize = (formData) => {
  const MAX_SIZE = 16384; // 16KB
  return JSON.stringify(formData).length <= MAX_SIZE;
}; 